import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CollectionDetailComponent } from '@app/account/shared/payment-checkout-wizard/collection/detail/detail.component';
import { CourseCardComponent } from '@app/account/shared/payment-checkout-wizard/user-service/course-card/course-card.component';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { UserCardMiniModule } from '@app/users/user-card-mini/user-card-mini.module';
import { DatetimePickerModule } from '@core/components/datetime-picker';
import { HorizontalScrollMenuModule } from '@core/components/horizontal-scroll-menu/horizontal-scroll-menu.module';
import { UserServiceCardModule } from '@core/components/service-card';
import { SpinnersModule } from '@core/components/spinners/spinners.module';

import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { PaymentFormCardSelectorModule } from 'lingo2-forms';
import { FormatPipe, FormatPipeModule } from 'lingo2-ngx-date-fns';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { OnUiButtonModule, OnUiCheckboxModule, OnUiCoverModule, OnUiReceiptModule } from 'onclass-ui';
import { PaymentWidgetModule } from '../../../shared/checkout-wizards/components/payment-widget';
import { CheckoutStepsComponent } from './checkout-steps/checkout-steps.component';
import { PaymentCheckoutWizardComponent } from './payment-checkout-wizard.component';
import { PaymentCheckoutWizardService } from './payment-checkout-wizard.service';
import { UserServiceDatetimeComponent } from './user-service/datetime/datetime.component';
import { UserServiceDetailComponent } from './user-service/detail/detail.component';

@NgModule({
  declarations: [
    PaymentCheckoutWizardComponent,
    CheckoutStepsComponent,
    UserServiceDetailComponent,
    CollectionDetailComponent,
    UserServiceDatetimeComponent,
  ],
  imports: [
    LocaleSharedModule,
    CommonModule,
    HorizontalScrollMenuModule,
    SpinnersModule,
    DatetimePickerModule,
    CourseCardComponent,

    UserCardMiniModule,
    FormatPipeModule,
    PaymentFormCardSelectorModule,
    OnUiReceiptModule,
    OnUiButtonModule,
    OnUiCoverModule,
    LazyLoadImageModule,
    OnUiCheckboxModule,
    IconComponent,
    PaymentWidgetModule,
    UserServiceCardModule,
    RatingComponent,
  ],
  exports: [PaymentCheckoutWizardComponent],
  providers: [PaymentCheckoutWizardService, FormatPipe],
})
export class PaymentCheckoutWizardModule {}
